export default __webpack_public_path__ + "static/media/Fun Cycling Days flyer.e6f04a3a.pdf";